import { GetChatMessageResponse } from '@distribute/shared/api-types/chat';
import { ChatMessageType } from '@distribute/shared/types';

/**
 * Formats chat messages based on streaming state
 *
 * @param messages - Array of chat messages to format
 * @param stream - Whether the chat is currently streaming
 * @returns Formatted array of chat messages
 *
 * @remarks
 * When streaming is active, removes any non-response messages from the end of the array
 * to ensure only complete responses are shown
 */
export const formatMessages = (
  messages: GetChatMessageResponse[],
  stream: boolean
): GetChatMessageResponse[] => {
  if (messages.length === 0) {
    return messages;
  }

  if (stream) {
    const _items: GetChatMessageResponse[] = [...messages];

    while (
      _items.length > 0 &&
      _items[_items.length - 1].content.type !== ChatMessageType.RESPONSE
    ) {
      _items.pop();
    }

    return _items;
  }

  return messages;
};
